import {POST} from "@/services/gateway";

const listUsers = ({pagination, searchTerm}) => {
  return POST('entra-id/users/list', {pagination, searchTerm})
}

export {
  listUsers
}
